import {createContext} from 'react'
import { RoleContextValue } from '../types/OtherTypes'

const roleContext = createContext<RoleContextValue>({
  features: [],
  roleName: undefined,
  updateState: () => {},
})

export default roleContext
